module.exports = __webpack_public_path__ + "static/media/institute-28-min.303f1af4.webp";